<div class="modal-header">
    <h5 class="modal-title" id="fecha-certificacion-titulo">Fecha de certificación</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <label for="fecha-certificacion" class="font-weight-bold">Seleccione la fecha de inicio del proceso:</label>
    <input id="fecha-certificacion" type="date" class="form-control" required
        [(ngModel)]="fechaCertificacion" [min]="fechaMinima"
        aria-describedby="fecha-certificacion-ayuda fecha-certificacion-error"
        [attr.aria-invalid]="!fechaCertificacionValida" />
    <small id="fecha-certificacion-ayuda" class="text-muted d-block mt-2">
        La activación de las certificaciones se completará entre 3 a 5 días hábiles a partir de la fecha seleccionada.
    </small>
    <small id="fecha-certificacion-error" class="text-danger d-block mt-2" role="alert">
        <ng-container *ngIf="!fechaCertificacionValida">Seleccione una fecha válida igual o posterior a hoy.</ng-container>
    </small>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="!fechaCertificacionValida"
        (click)="confirmar()">Continuar al pago</button>
</div>
